<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/config/customer/dictionary/item/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('zidianleixing')">
            <el-select filterable :clearable="true" v-model="yt.conditions.typeId">
              <el-option v-for="(item, index) in dictionaryList" :key="index" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('zidianzhi')">
            <el-input v-model="yt.conditions.value"></el-input>
          </el-form-item>
          <el-form-item :label="$t('biaoqian')">
            <el-input v-model="yt.conditions.label"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" v-if="utils.checkPower('web_customer_dictionary_item_create')" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button size="mini" :loading="yt.editObj.loading" v-if="utils.checkPower('web_customer_dictionary_item_reset')" @click="resetDictionaries" plain>
          {{ $t('chongzhizidian') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <!-- <template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
				</el-button>
			</template> -->
      <!-- 自定义某个字段 -->



      <template #zidianleixing="scope">
        {{ $t(scope.row.typeName) }}
      </template>


      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_customer_dictionary_item_update')" @click="yt.showEditDialog('bianji', scope.row)">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" v-if="utils.checkPower('web_customer_dictionary_item_delete')" class="font-color-danger" @click="yt.remove(scope.row, '/web/config/customer/dictionary/item/delete')">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('zidianleixing')" required="required">
            <el-select filterable :clearable="true" v-model="yt.editObj.typeId">
              <el-option v-for="(item, index) in dictionaryList" :key="index" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('zidianzhi')" required="required">
            <el-input v-model="yt.editObj.value" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item :label="$t('biaoqian')" required="required">
            <el-input v-model="yt.editObj.label" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shunxu')">
            <!-- <el-input v-model="yt.editObj.priority" maxlength="8" ></el-input> -->
            <yi_number_input :min="1" :type="'number'" @input="yt.editObj.priority = String(yt.editObj.priority).replace(/[^\d]/g, '')" :start.sync="yt.editObj.priority"></yi_number_input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/config/customer/dictionary/item/create')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 编辑表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('zidianleixing')" required="required">
            <el-select filterable :clearable="true" v-model="yt.editObj.typeId" disabled>
              <el-option v-for="(item, index) in dictionaryList" :key="index" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('zidianzhi')" required="required">
            <el-input v-model="yt.editObj.value" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('biaoqian')" required="required">
            <el-input v-model="yt.editObj.label" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shunxu')">
            <yi_number_input :min="1" :type="'number'" @input="yt.editObj.priority = String(yt.editObj.priority).replace(/[^\d]/g, '')" :start.sync="yt.editObj.priority"></yi_number_input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/config/customer/dictionary/item/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_system_dictionary_list',
  data() {
    return {
      status: [
        {
          label: this.$t('shi'),
          value: true
        },
        {
          label: this.$t('fou'),
          value: false
        }
      ],
      dictionaryList: [],
      list: [],
      rolesList: [],
      organizationList: [],
      columns: [
        {
          label: 'zidianleixing',
          type: 'slot',
        },
        {
          label: 'zidianzhi',
          prop: 'value'
        },
        {
          label: 'biaoqian',
          prop: 'label'
        },
        {
          label: 'shunxu',
          prop: 'priority'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
      this.getDictCatList();
    }, 300);
  },

  methods: {
    resetDictionaries() {
      this.$confirm(this.$t('chongzhihousuoyouzidianjiangbeimorenzidianmobanshujufugai'), this.$t('jinggao'), {
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no'),
        confirmButtonClass: 'el-button--danger',
        type: 'warning'
      }).then(() => {
        this.http.get('/web/config/customer/dictionary/item/reset', {}).then(() => {
          this.yt.get(1);
        });
      });
    },
    async getDictCatList() {
      let response = await this.http.get('/web/config/customer/dictionary/type/listAll', {
        params: {
          //pageNum: 1,
          //pageSize: 100
        }
      });
      this.dictionaryList = response.data;
    }
  }
};
</script>
